export default __webpack_public_path__ + "static/media/voucher.68254584.svg";